import { InputField, Label, Row, SwitchToggle } from "client/CommonComponents";
import './CategoryManagement.scss';

const EditCategoryModal = ({ form, formError, handleChange }: any) => {
  return (
    <>
      <Row>
        <Label required title="name" data-attribute="EditCategoryModal_name_Label">
          Name
        </Label>
        <InputField name="categoryName" className="mb-3" onChange={handleChange} value={form?.categoryName}  data-attribute="EditCategoryModal_categoryName_Input" />
        {formError ? (
          <span className="category-validation-msg">
            {formError}
          </span>
        ) : null}
        <Label title="active" data-attribute="EditCategoryModal_active_Label">
          Active
        </Label>
        <SwitchToggle name="isActive" onChange={handleChange} checked={form?.isActive}  data-attribute="EditCategoryModal_isActive_SwitchToggle" />
      </Row>
    </>
  );
};

export default EditCategoryModal;
